import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

const NAV_LINKS = [
  { label: "About",      to: "/about" },
  { label: "Programs",   to: "/programs" },
  { label: "Membership", to: "/membership" },
  { label: "Impact",     to: "/impact" },
  { label: "Contact",    to: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const location                  = useLocation();
  const navigate                  = useNavigate();
  const { currentUser, logout }   = useAuth();
  const isDashboard = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/admin");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setMenuOpen(false); }, [location]);

  if (isDashboard) return null;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <>
      <style>{`
        .navbar {
          position:fixed; top:0; left:0; right:0; z-index:200;
          padding:0 5vw; display:flex; align-items:center; justify-content:space-between;
          height:70px; transition:all 0.4s ease;
        }
        .navbar.scrolled {
          background:rgba(7,20,40,0.97); backdrop-filter:blur(16px);
          box-shadow:0 2px 30px rgba(0,0,0,0.3);
        }
        .nav-logo { display:flex; align-items:center; gap:10px; }
        .logo-text { font-family:'Playfair Display',serif; color:white; font-size:16px; font-weight:700; line-height:1.2; }
        .logo-sub { display:block; font-size:10px; font-family:'DM Sans',sans-serif; font-weight:400; color:#E8B96A; letter-spacing:2px; text-transform:uppercase; }
        .nav-links { display:flex; gap:28px; }
        .nav-link { color:rgba(255,255,255,0.8); font-size:14px; font-weight:500; letter-spacing:0.3px; transition:color 0.2s; position:relative; padding:4px 0; }
        .nav-link::after { content:''; position:absolute; bottom:-2px; left:0; right:0; height:1px; background:#E8B96A; transform:scaleX(0); transition:transform 0.2s; }
        .nav-link:hover, .nav-link.active { color:#E8B96A; }
        .nav-link:hover::after, .nav-link.active::after { transform:scaleX(1); }
        .nav-actions { display:flex; gap:12px; align-items:center; }
        .nav-cta { background:linear-gradient(135deg,#C9963E,#E8B96A); color:#0B1F3A; padding:9px 20px; border-radius:4px; font-weight:700; font-size:13px; transition:all 0.2s; }
        .nav-cta:hover { transform:translateY(-1px); box-shadow:0 4px 16px rgba(201,150,62,0.4); }
        .hamburger { display:none; flex-direction:column; gap:5px; cursor:pointer; padding:4px; }
        .hamburger span { width:22px; height:2px; background:white; border-radius:2px; transition:0.3s; display:block; }
        .mobile-menu { display:none; position:fixed; inset:0; top:70px; background:rgba(7,20,40,0.98); z-index:199; flex-direction:column; align-items:center; justify-content:center; gap:28px; height: calc(100dvh - 70px); }
        .mobile-menu.open { display:flex; }
        .mobile-link { color:white; font-size:20px; font-family:'Playfair Display',serif; font-weight:700; }
        @media(max-width:900px){ .nav-links,.nav-actions{display:none;} .hamburger{display:flex;} }
      `}</style>

      <nav className={`navbar${scrolled?" scrolled":""}`}>
        <Link to="/" className="nav-logo">
          <Logo />
          <div className="logo-text">
            Revolutionary Foundation
            <span className="logo-sub">Est. 2019 · Nigeria</span>
          </div>
        </Link>
        <ul className="nav-links">
          {NAV_LINKS.map(l=>(
            <li key={l.to}>
              <Link to={l.to} className={`nav-link${location.pathname===l.to?" active":""}`}>{l.label}</Link>
            </li>
          ))}
        </ul>
        <div className="nav-actions">
          {currentUser ? (
            <>
              <Link to="/dashboard" style={{color:"rgba(255,255,255,0.7)",fontSize:13,fontWeight:500,transition:"color 0.2s"}} onMouseEnter={e=>e.target.style.color="#E8B96A"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,0.7)"}>Dashboard</Link>
              <button onClick={handleLogout} style={{color:"rgba(255,255,255,0.5)",fontSize:13,background:"none",border:"none",cursor:"pointer"}}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" style={{color:"rgba(255,255,255,0.7)",fontSize:13,fontWeight:500}}>Member Login</Link>
              <Link to="/apply" className="nav-cta">Apply for Grant</Link>
            </>
          )}
        </div>
        <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
          <span/><span/><span/>
        </div>
      </nav>

      <div className={`mobile-menu${menuOpen?" open":""}`}>
        {NAV_LINKS.map(l=>(
          <Link key={l.to} to={l.to} className="mobile-link">{l.label}</Link>
        ))}
        {currentUser ? (
          <>
            <Link to="/dashboard" className="btn-primary" style={{marginTop:8}}>Dashboard</Link>
            <button onClick={handleLogout} style={{color:"#E8B96A",fontSize:16,background:"none",border:"1px solid #E8B96A",padding:"8px 16px",borderRadius:4,cursor:"pointer",marginTop:8}}>Sign Out</button>
          </>
        ) : (
          <>
            <Link to="/login" className="btn-outline" style={{marginTop:8}}>Member Login</Link>
            <Link to="/apply" className="btn-primary">Apply for Grant</Link>
          </>
        )}
      </div>
    </>
  );
}
